// §V2 exact port — the spike's {i:name} icon vocabulary mapped onto
// lucide-preact (the spike's paths are Lucide-style, 24-grid, stroke=
// currentColor — same visual language). One component, spike names.
import type { JSX } from 'preact';
import {
  Home, Compass, LayoutGrid, BookOpen, Search, Sparkles, Wand2, Rocket,
  Check, X, ChevronRight, ChevronLeft, ArrowRight, ArrowLeft, Plus, Share2,
  Copy, ExternalLink, Bell, Lock, ShieldCheck, Trash2, Globe, Sun, Moon,
  Smartphone, UserRound, CreditCard, Coins, Flame, LifeBuoy, Settings,
  Palette, SlidersHorizontal, Type, Image, History, Send, Mail,
  MessageSquare, Target, Zap, Lightbulb, Calendar, Paperclip, Dices, Heart,
  Clock, Eye, Download, Pencil, Layers, Droplet, Menu, Wrench, BarChart3,
  LogOut,
  Plug,
  type LucideIcon
} from 'lucide-preact';

const MAP: Record<string, LucideIcon> = {
  home: Home, compass: Compass, grid: LayoutGrid, book: BookOpen, plug: Plug,
  search: Search, spark: Sparkles, wand: Wand2, rocket: Rocket, check: Check,
  x: X, chev: ChevronRight, chevl: ChevronLeft, arrow: ArrowRight,
  arrowl: ArrowLeft, plus: Plus, share: Share2, copy: Copy, ext: ExternalLink,
  bell: Bell, lock: Lock, shield: ShieldCheck, trash: Trash2, globe: Globe,
  sun: Sun, moon: Moon, phone: Smartphone, user: UserRound, card: CreditCard,
  coin: Coins, flame: Flame, life: LifeBuoy, gear: Settings, palette: Palette,
  sliders: SlidersHorizontal, type: Type, image: Image, history: History,
  send: Send, mail: Mail, msg: MessageSquare, target: Target, bolt: Zap,
  bulb: Lightbulb, cal: Calendar, calendar: Calendar, clip: Paperclip,
  dice: Dices, heart: Heart, clock: Clock, eye: Eye, download: Download,
  pencil: Pencil, layers: Layers, drop: Droplet, menu: Menu, wrench: Wrench,
  chart: BarChart3, logout: LogOut
};

/** `<Ic n="spark" />` ≙ the spike's `{i:spark}` placeholder. */
export function Ic({ n, size = 16 }: { n: string; size?: number }): JSX.Element | null {
  const C = MAP[n];
  return C ? <C size={size} strokeWidth={2} class="icon" aria-hidden="true" /> : null;
}

/** i18n helper for the exact-port screens: returns the translated string
 *  when the catalog has one, else the spike's exact English copy. Keys are
 *  registered centrally in lib/i18n.ts (EN uses these same fallbacks). */
import { t } from '../lib/i18n';
export function tt(key: string, exactEnglish: string): string {
  const v = t(key);
  return v && v !== key ? v : exactEnglish;
}
